import React from "react";
import styled from 'styled-components';
import I10n from '../../features/i10n';
import PropTypes from 'prop-types';
import ApplicationParameterMenu from '../../components/application_parameter_menu';

const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const Title = styled.span`
    display: inline-block;
    margin-top: 0;
    margin-bottom: 0;
    font-size: 24px;
    font-weight: bold;
    color: rgb(98, 100, 105);
    @media (max-width: 800px) {
      font-size: 18px;
    }
  `;

class AppTitle extends React.PureComponent {

  static propTypes = {
    title: PropTypes.string,
    selectedLengthUnit: PropTypes.string,
    setParameters: PropTypes.func
  }

  render() {
    return (
      <TitleWrapper>
        <Title>{this.props.title ? this.props.title : I10n.get('app.title')}</Title>
        <ApplicationParameterMenu
          selectedLengthUnit={this.props.selectedLengthUnit}
          setParameters={this.props.setParameters}></ApplicationParameterMenu>
      </TitleWrapper>
    );
  }
}

export default AppTitle;
